import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Card, Table, ProgressBar, Button, Navbar, Nav } from "react-bootstrap";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  Paging,
} from "devextreme-react/data-grid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import TextField from "@material-ui/core/TextField";
import { useStyles } from "../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import Grid from "@material-ui/core/Grid";
import swal from "sweetalert";
import Button1 from "@material-ui/core/Button";
import Select from "react-select";
import { useNavigate } from "react-router";
import { api_path } from "../shared.js";
export function SalesDashboardComponent(props) {
  const classes = useStyles();
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
 

  return (
    <Container maxWidth="xl">
      <br /> <br />
      <Grid container spacing={2}>
        <label className="head">Dashboard</label>
      </Grid>
      <Grid container spacing={2}>
      <Container fluid>
        {/* 1. Sales Overview */}
        <Row className="mb-4">
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title>Sales Overview</Card.Title>
                <h3>$150,000</h3>
                <ProgressBar now={75} label="75%" />
              </Card.Body>
            </Card>
          </Col>

          {/* 2. Transport Overview */}
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title>Transport Overview</Card.Title>
                <Table bordered size="sm">
                  <thead>
                    <tr>
                      <th>Route</th>
                      <th>Status</th>
                      <th>Delivered</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Bangkok - Chiang Mai</td>
                      <td>In Transit</td>
                      <td>320</td>
                    </tr>
                    <tr>
                      <td>Bangkok - Phuket</td>
                      <td>Completed</td>
                      <td>280</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* 3. Top 10 Customers */}
        <Row className="mb-4">
          <Col>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title>Top 10 Customers</Card.Title>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Customer</th>
                      <th>Total Orders</th>
                      <th>Revenue</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.from({ length: 10 }).map((_, i) => (
                      <tr key={i}>
                        <td>Customer #{i + 1}</td>
                        <td>{Math.floor(Math.random() * 100)}</td>
                        <td>${Math.floor(Math.random() * 10000)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* 4. Summary Activities */}
        <Row className="mb-4">
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title>Summary Activities</Card.Title>
                <ul>
                  <li>Calls Made: 120</li>
                  <li>Emails Sent: 230</li>
                  <li>Meetings Scheduled: 50</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>

          {/* 5. Recent Activities */}
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title>Recent Activities</Card.Title>
                <Table size="sm">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Activity</th>
                      <th>Customer</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2025-04-21</td>
                      <td>Call</td>
                      <td>Alpha Ltd.</td>
                    </tr>
                    <tr>
                      <td>2025-04-20</td>
                      <td>Meeting</td>
                      <td>Beta Co.</td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* 6. Upcoming Tasks */}
        <Row className="mb-4">
          <Col>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title>Upcoming Tasks</Card.Title>
                <ul>
                  <li>Follow up with Charlie Co. - 2025-04-23</li>
                  <li>Prepare sales report - 2025-04-24</li>
                  <li>On-site visit with Delta Inc. - 2025-04-25</li>
                </ul>
                <Button variant="primary" size="sm">Add Task</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {/* <Grid item xs={12} sm={4}>
        <h2>Sales Overview</h2>
        </Grid>
        <Grid item xs={12} sm={4}>
          <h2>Transport Overview</h2>
        </Grid>
        <Grid item xs={12} sm={4}>
          <h2>Upcoming Task</h2>
        </Grid>
        <Grid item xs={12} sm={4}>
        <h2>Sales Pipeline</h2>
        </Grid>
        <Grid item xs={12} sm={4}>
        <h2>Top 10 Customers</h2>
        </Grid>
        <Grid item xs={12} sm={4}>
          <h2>Recent Activities</h2>
        </Grid> */}
     
      </Grid>
    </Container>
  );
}
